import React, { useState } from "react";
import { Link } from "react-router-dom";
import ContactModal from "../features/ContactModal";
import LanguageSwitcher from "../common/LanguageSwitcher";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <footer className="bg-primary bg-opacity-30 text-white py-6 font-body w-full bottom-0">
      <div className="container mx-auto flex flex-col items-center justify-center px-4 text-center">

        {/* 🌐 Texto legal centrado */}
        <div className="text-sm sm:text-base mb-2">
          © {new Date().getFullYear()} Slowork. {t("footer.rights")} 
          <span className="mx-2 text-secondary">|</span>
          <Link to="/privacy-policy" className="hover:text-secondary">{t("footer.privacy")}</Link>
          <span className="mx-2">|</span>
          <button onClick={() => setIsModalOpen(true)} className="hover:text-secondary">{t("footer.contact")}</button>
          <span className="mx-2">|</span>
          <Link to="/cookies-policy" className="hover:text-secondary">{t("footer.cookiesPolicy")}</Link>
          <span className="mx-2">|</span>
          <Link to="/legal-notice" className="hover:text-secondary">{t("footer.legalNotice")}</Link>
          <span className="mx-2">|</span>
          <Link to="/terms-and-conditions" className="hover:text-secondary">{t("footer.terms")}</Link>
        </div>

        {/* 🌍 Selector de idioma centrado debajo */}
        <LanguageSwitcher />

        {/* 📩 Modal de contacto */}
        <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div>
    </footer>
  );
};

export default Footer;
